module.exports = __webpack_public_path__ + "img/户号管理.798ecc2b.png";